import {
  Box,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

interface Props {
  columns: number;
}

export function AssetTableSkeleton(props: Props) {
  const columns = props.columns;

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="asset table">
        <TableHead>
          <TableRow>
            {Array.from(Array(columns)).map((_, index) => (
              <TableCell
                key={index}
                sx={{
                  width: (columns - 1 && columns > 5) == index ? '20%' : 'auto',
                }}
              >
                <Skeleton variant="text" width="100%" height={24} />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from(Array(4)).map((_, index) => (
            <TableRow key={`row-${index}`}>
              {Array.from(Array(columns)).map((_, index) => (
                <TableCell
                  key={`cell-${index}`}
                  sx={{ width: columns - 1 === index ? '20%' : 'auto' }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Skeleton
                      variant="circular"
                      width={20}
                      height={20}
                      sx={{ mr: 1 }}
                    />
                    <Box>
                      <Skeleton variant="text" width={140} height={24} />
                    </Box>
                  </Box>
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
